export class FasIcon {
  constructor(icon_name) {
    let prefix;
    let name;

    if (icon_name) {
      const split = icon_name.split(" ");
      prefix = split[0];
      name = split[1];
    }

    this.prefix = prefix ? prefix : "fas";
    this.name = name ? name : "asterisk";

    // console.log("created new fas-icon", this);
  }
}
